// messagesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import configData from '../configure';

export const sendNotification = createAsyncThunk(
  'messages/sendNotification',
  async ({ messageBody, specificUserIds, token, axiosInstance }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      
      // Prepare the request JSON
      const requestData = {
        subject: 'hi', // Hardcoded as in your original code; adjust if dynamic
        messageBody,
        userType: 'STUDENT',
        specificUserIds: [specificUserIds]
      };
      
      // Append request as a JSON string
      formData.append('request', JSON.stringify(requestData));
      
      // Append attachments (optional; using 'string' as per curl example)
      formData.append('attachments', 'string'); // Replace with actual file if needed

      const response = await axiosInstance.post(
        configData.INFRASTRUCTURE_NOTIFICATIONS_EMAIL,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/hal+json' // Match curl's accept header
            // Note: Don't set Content-Type manually; axios sets it with boundary
          }
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const messagesSlice = createSlice({
  name: 'messages',
  initialState: {
    message: '',
    status: { type: '', message: '' },
    isLoading: false,
    error: null
  },
  reducers: {
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    clearMessage: (state) => {
      state.message = '';
    },
    clearStatus: (state) => {
      state.status = { type: '', message: '' };
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendNotification.pending, (state) => {
        state.isLoading = true;
        state.status = { type: '', message: '' };
        state.error = null;
      })
      .addCase(sendNotification.fulfilled, (state) => {
        state.isLoading = false;
        state.status = { type: 'success', message: 'Notification sent successfully!' };
        state.message = '';
      })
      .addCase(sendNotification.rejected, (state, action) => {
        state.isLoading = false;
        state.status = { type: 'error', message: action.payload || 'Failed to send notification' };
        state.error = action.payload;
      });
  }
});

export const { setMessage, clearMessage, clearStatus, setStatus } = messagesSlice.actions;
export default messagesSlice.reducer;